// M-06: Suppress console output in production to avoid leaking
// technical details (stack traces, paths, internal error messages)
// to users who open browser DevTools.
const isDev = import.meta.env.DEV;

export const logger = {
  error: isDev ? console.error.bind(console) : () => {},
  warn:  isDev ? console.warn.bind(console)  : () => {},
  log:   isDev ? console.log.bind(console)   : () => {},
};
